<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">LIQUIDACIONES</h1>
        </section>

        <section id="body">
            <mat-card class="mat-elevation-z0">
                <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="1rem" id="filters">
                    <div fxFlex="50">
                        <mat-form-field appearance="outline">
                            <mat-label>Desde</mat-label>
                            <input matInput [matDatepicker]="dateFrom">
                            <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                            <mat-datepicker #dateFrom>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div fxFlex="50">
                        <mat-form-field appearance="outline">
                            <mat-label>Hasta</mat-label>
                            <input matInput [matDatepicker]="dateTo">
                            <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                            <mat-datepicker #dateTo>
                            </mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div fxFlex="10">
                        <button mat-flat-button class="squared-btn">Buscar</button>
                    </div>
                </div>

                <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" id="table">

                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ID</th>
                        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                    </ng-container>

                    <ng-container matColumnDef="fecha">
                        <th mat-header-cell *matHeaderCellDef class="table-header">FECHA</th>
                        <td mat-cell *matCellDef="let element"> {{element.fecha}} </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL</th>
                        <td mat-cell *matCellDef="let element"> {{element.total}} </td>
                    </ng-container>

                    <ng-container matColumnDef="neto">
                        <th mat-header-cell *matHeaderCellDef class="table-header">NETO</th>
                        <td mat-cell *matCellDef="let element"> {{element.neto}} </td>
                    </ng-container>

                    <ng-container matColumnDef="commision">
                        <th mat-header-cell *matHeaderCellDef class="table-header">COMISIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.commision}} </td>
                    </ng-container>

                    <ng-container matColumnDef="liquidacion">
                        <th mat-header-cell *matHeaderCellDef class="table-header">LIQUIDACIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.liquidacion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="pdf" ¡>
                        <th mat-header-cell *matHeaderCellDef class="table-header">PDF</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-flat-button class="squared-btn" (click)="generarPDF()">Generar</button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>
